// import * as  firebase from 'firebase/app'
// import 'firebase/firestore'
// import 'firebase/messaging';

// // Get a Firestore instance
// const firebaseApp = firebase
//   .initializeApp({
//     apiKey: "AIzaSyCEmowPh6EptWo8zSfsyS-s1RyUrZ6dEXE",
//     authDomain: "mi-test-b974c.firebaseapp.com",
//     databaseURL: "https://mi-test-b974c.firebaseio.com",
//     projectId: "mi-test-b974c",
//     storageBucket: "mi-test-b974c.appspot.com",
//     messagingSenderId: "522488069651",
//     appId: "1:522488069651:web:cdb0573194c6fbdfc949e6"
//   });

//   const db = firebaseApp.firestore();



// // Export types that exists in Firestore
// // This is not always necessary, but it's used in other examples

// const { Timestamp, GeoPoint } = firebaseApp.firestore


// export { Timestamp, GeoPoint }


// export { db,firebaseApp }; 

import firebase from 'firebase/app'
import 'firebase/firestore';
import 'firebase/messaging';
import 'firebase/storage';

const config = {
    apiKey: "AIzaSyCEmowPh6EptWo8zSfsyS-s1RyUrZ6dEXE",
    authDomain: "mi-test-b974c.firebaseapp.com",
    databaseURL: "https://mi-test-b974c.firebaseio.com",
    projectId: "mi-test-b974c",
    storageBucket: "mi-test-b974c.appspot.com",
    messagingSenderId: "522488069651",
    appId: "1:522488069651:web:cdb0573194c6fbdfc949e6"
}

const fb = firebase.initializeApp(config)

// Initialize Cloud Firestore through Firebase
const db = fb.firestore();

// Disable deprecated features
// db.settings({
//   timestampsInSnapshots: true
// });

// db.enablePersistence({experimentalTabSynchronization:true})

const storage = fb.storage()

let messaging = null;
try {
    // messaging = messaging();
    messaging = fb.messaging();
} catch (err) {
    messaging  = null;
    console.log("No es posible finalizar la operacion . . . ", err)
}
if( messaging != null )
    messaging.usePublicVapidKey("BHviwvR2qF_lMrZP5MdUE56J9Z6nGowNYKnRxa0Y5-0Hk94vKi_Ju9MsIfu4kPlZgcrd0ANpbVJPTKsOPK0NLcE");

export default { db, storage, messaging }